import { api_url } from "../configiration/config";
import { axiosClone } from './../axiosClone';

//Offers 
export async function getOffers(){
    return await axiosClone.get(`${api_url}/offers`);
}